import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";
import { cambiosSinGuardarGuard } from "@core/guards/cambios-sin-guardar.guard";

export const haberesRoutes: Routes = [
  {
    path: "lh_inicio",
    loadComponent: () =>
      import("./components/inicio/inicio.component").then(
        (m) => m.InicioHaberesComponent,
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_convenios_y_categorias",
    loadComponent: () =>
      import("./components/convenios-y-categorias/convenios-y-categorias.component").then(
        (m) => m.ConveniosYCategoriasComponent,
      ),
    data: {
      label: "Convenios y Categorías",
      icon: "assignment",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_convenios_y_categorias/categorias",
    loadComponent: () =>
      import("./components/convenios-y-categorias/categorias/categorias.component").then(
        (m) => m.CategoriasComponent,
      ),
    data: {
      label: "Categorías por Convenio",
      icon: "category",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_obras-planes",
    loadChildren: () =>
      import("./components/obras-sociales/obras-sociales.routes").then(
        (m) => m.obrasSocialesRoutes,
      ),
    data: {
      label: "Obras Sociales y Planes",
      icon: "health_and_safety",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_obras_sociales/planes",
    loadComponent: () =>
      import("./components/obras-sociales/planes-obra-social/planes-obra-social.component").then(
        (m) => m.PlanesObraSocialComponent,
      ),
    data: {
      label: "Planes por Obra Social",
      icon: "list_alt",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_parametros-emp",
    loadChildren: () =>
      import("./components/parametricos_emp/parametricos_emp.routes").then(
        (m) => m.parametricosEmpRoutes,
      ),
    data: {
      label: "Parametricos_emp",
      icon: "list_alt",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_parametros-pais",
    loadChildren: () =>
      import("./components/parametricos_pais/parametricos-pais.routes").then(
        (m) => m.parametricosPaisRoutes,
      ),
    data: {
      label: "Parametricos_pais",
      icon: "language",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_orden-conc-recibo-sueldos",
    loadChildren: () =>
      import("./components/orden-conceptos-recibo/orden-conceptos-recibo.routes").then(
        (m) => m.ordenConceptosReciboRoutes,
      ),
    data: {
      label: "Orden Conceptos Recibo",
      icon: "receipt_long",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_liquidaciones",
    loadChildren: () =>
      import("./components/liquidaciones/liquidaciones.routes").then(
        (m) => m.liquidacionesRoutes,
      ),
    data: {
      label: "Liquidaciones",
      icon: "table_view",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_situacion-revista",
    loadComponent: () =>
      import("./components/situacion_revista/situacion-revista.component").then(
        (m) => m.SituacionRevistaHaberesComponent,
      ),
    data: {
      label: "Situacion_Revista",
      icon: "table_rows",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_conceptos",
    loadChildren: () =>
      import("./components/conceptos/conceptos.routes").then(
        (m) => m.conceptosRoutes,
      ),
    data: {
      label: "Conceptos",
      icon: "dashboard_customize",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_bases-imponibles",
    loadComponent: () =>
      import("./components/bases-imponibles/bases-imponibles.component").then((m) => m.BasesImponiblesComponent),
    data: {
      label: "Bases_Imponibles",
      icon: "account_balance_wallet",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_parametros-conceptos",
    loadComponent: () =>
      import(
        "./components/parametros-conceptos/parametros-conceptos.component"
      ).then((m) => m.ParametrosConceptosComponent),
    data: {
      label: "Parametros_Conceptos",
      icon: "tune",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_conceptos-parametro",
    loadComponent: () =>
      import(
        "./components/conceptos-parametro/conceptos-parametro.component"
      ).then((m) => m.ConceptosParametroComponent),
    data: {
      label: "Conceptos_Parametro",
      icon: "filter_alt",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_desbloqueo-liq",
    loadChildren: () =>
      import("./components/desbloqueo/desbloqueo.routes").then(
        (m) => m.desbloqueoRoutes,
      ),
    data: {
      label: "Desbloqueo",
      icon: "lock_open",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reversion-liq",
    loadChildren: () =>
      import("./components/reversion/reversion.routes").then(
        (m) => m.reversionRoutes,
      ),
    data: {
      label: "Reversion",
      icon: "undo",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_novedades-masivas",
    loadChildren: () =>
      import("./components/novedades_masivas/novedades-masivas.routes").then(
        (m) => m.novedadesMasivasRoutes,
      ),
    data: {
      label: "Novedades_Masivas",
      icon: "all_inbox",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_novedades-generales",
    loadChildren: () =>
      import("./components/novedades_generales/novedades-generales.routes").then(
        (m) => m.novedadesGeneralesRoutes,
      ),
    data: {
      label: "Novedades_Generales",
      icon: "inbox",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reporte-novedades-generales",
    loadChildren: () =>
      import(
        "./components/reporte_novedades_generales/reporte-novedades-generales.routes"
      ).then((m) => m.reporteNovedadesGeneralesRoutes),
    data: {
      label: "Reporte_Novedades_Generales",
      icon: "summarize",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reporte-novedades-legajo",
    loadChildren: () =>
      import(
        "./components/reporte_novedades_legajo/reporte-novedades-legajo.routes"
      ).then((m) => m.reporteNovedadesLegajoRoutes),
    data: {
      label: "Reporte_Novedades_Legajo",
      icon: "summarize",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reporte-novedades-masivas",
    loadChildren: () =>
      import(
        "./components/reporte_novedades_masivas/reporte-novedades-masivas.routes"
      ).then((m) => m.reporteNovedadesMasivasRoutes),
    data: {
      label: "Reporte_Novedades_Masivas",
      icon: "summarize",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_procesos-adicionales",
    loadChildren: () =>
      import("./components/procesos_adicionales/procesos-adicionales.routes").then(
        (m) => m.procesosAdicionalesRoutes,
      ),
    data: {
      label: "Procesos_Adicionales",
      icon: "autorenew",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_formatos-bancarios",
    loadComponent: () =>
      import("./components/formatos-bancarios/formatos-bancarios.component").then(
        (m) => m.FormatosBancariosComponent,
      ),
    data: {
      label: "Formatos_Bancarios",
      icon: "description",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reversion-acreditaciones",
    loadChildren: () =>
      import("./components/reversion_acred/reversion-acred.routes").then(
        (m) => m.reversionAcredRoutes,
      ),
    data: {
      label: "Reversion_Acreditaciones",
      icon: "history",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_importacion-novedades",
    loadChildren: () =>
      import("./components/importacion_novedades/importacion-novedades.routes").then(
        (m) => m.importacionNovedadesRoutes,
      ),
    data: {
      label: "Importacion_Novedades",
      icon: "publish",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_actualizacion-novedades",
    loadChildren: () =>
      import("./components/actualizacion_novedades/actualizacion-novedades.routes").then(
        (m) => m.actualizacionNovedadesRoutes,
      ),
    data: {
      label: "Actualizacion_Novedades",
      icon: "update",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_escalas-deducciones",
    loadComponent: () =>
      import("./components/escalas_deducciones/escalas_deducciones.component").then(
        (m) => m.EscalasDeduccionesComponent,
      ),
    data: {
      label: "Escalas_Deducciones",
      icon: "account_balance",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_uru-esc-nov",
    loadComponent: () =>
      import("./components/escalas_novedades/escalas-novedades-uruguay.component").then(
        (m) => m.EscalasNovedadesUruguayComponent,
      ),
    data: {
      label: "Uruguay_Escalas_Novedades",
      icon: "flag",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_codigos-liquidacion",
    loadComponent: () =>
      import("./components/codigo_liquidaciones/codigo-liquidaciones.component").then(
        (m) => m.CodigoLiquidacionesComponent,
      ),
    data: {
      label: "Codigos_Liquidacion",
      icon: "list_alt",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_modelos-algoritmo",
    loadComponent: () =>
      import("./components/modelos_algoritmos/modelos-algoritmos.component").then(
        (m) => m.ModelosAlgoritmosComponent,
      ),
    data: {
      label: "Modelos_Algoritmos",
      icon: "account_tree",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_clasificadores-bloque",
    loadComponent: () =>
      import("./components/clasificadores_bloque/clasificadores-bloque.component").then(
        (m) => m.ClasificadoresBloqueComponent,
      ),
    data: {
      label: "Clasificadores_Bloque",
      icon: "list_alt",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_bloques-algoritmo",
    loadComponent: () =>
      import("./components/bloques_algoritmos/bloques-algoritmos.component").then(
        (m) => m.BloquesAlgoritmosComponent,
      ),
    data: {
      label: "Bloques_Algoritmos",
      icon: "account_tree",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_algoritmos-concepto",
    loadComponent: () =>
      import("./components/algoritmos-concepto/algoritmos-concepto.component").then(
        (m) => m.AlgoritmosConceptoComponent,
      ),
    data: {
      label: "Algoritmos_Concepto",
      icon: "functions",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_algoritmos-operador",
    loadComponent: () =>
      import("./components/algoritmos-operador/algoritmos-operador.component").then(
        (m) => m.AlgoritmosOperadorComponent,
      ),
    data: {
      label: "Algoritmos_Operador",
      icon: "manage_search",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_algoritmo-calculo",
    loadComponent: () =>
      import("./components/algoritmos-calculo/algoritmos-calculo.component").then(
        (m) => m.AlgoritmosCalculoComponent,
      ),
    data: {
      label: "Algoritmos_Calculo",
      icon: "functions",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
    canDeactivate: [cambiosSinGuardarGuard],
  },
  {
    path: "lh_asiento-imputacion",
    loadComponent: () =>
      import("./components/contabilizacion/asiento-imput/asiento-imput.component").then(
        (m) => m.AsientoImputComponent,
      ),
    data: {
      label: "Asiento_Imputacion",
      icon: "receipt_long",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_asiento-cuenta",
    loadComponent: () =>
      import("./components/contabilizacion/asiento-cuenta/asiento-cuenta.component").then(
        (m) => m.AsientoCuentaComponent,
      ),
    data: {
      label: "Asiento por Cuenta",
      icon: "account_balance",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_distribucion-contable-cres",
    loadComponent: () =>
      import(
        "./components/contabilizacion/distribucion-cres/distribucion-cres.component"
      ).then((m) => m.DistribucionCresComponent),
    data: {
      label: "Distribución Contable por Centro de Resultado",
      icon: "pie_chart",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_carga-acumulados-legajo",
    loadComponent: () =>
      import("./components/carga-acumulados-legajo/carga-acumulados-legajo.component").then(
        (m) => m.CargaAcumuladosLegajoComponent,
      ),
    data: {
      label: "Carga Inicial de Acumulados por Legajo",
      icon: "layers",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_carga-acumulados-externos",
    loadComponent: () =>
      import("./components/acumulados-iniciales/acumulados-iniciales.component").then(
        (m) => m.AcumuladosInicialesComponent,
      ),
    data: {
      label: "Carga Inicial de Acumulados Externos",
      icon: "layers",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_acumulados-legajo",
    loadComponent: () =>
      import("./components/acumulados_legajo/acumulados-legajo.component").then(
        (m) => m.AcumuladosLegajoComponent,
      ),
    data: {
      label: "Acumulados_Legajo",
      icon: "layers",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_conceptos-base",
    loadComponent: () =>
      import("./components/bases_legajo/bases-legajo.component").then(
        (m) => m.BasesLegajoComponent,
      ),
    data: {
      label: "Bases_Legajo",
      icon: "calculate",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_log-liquidacion",
    loadComponent: () =>
      import("./components/log-liquidacion/log-liquidacion.component").then(
        (m) => m.LogLiquidacionComponent,
      ),
    data: {
      label: "Log_Liquidacion",
      icon: "history",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_control-liquidacion",
    loadComponent: () =>
      import("./components/control-liquidacion/control-liquidacion.component").then(
        (m) => m.ControlLiquidacionComponent,
      ),
    data: {
      label: "Control_Liquidacion",
      icon: "account_tree",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reporte-control-liquidacion",
    loadComponent: () =>
      import(
        "./components/reporte-control-liquidacion/reporte-control-liquidacion.component"
      ).then((m) => m.ReporteControlLiquidacionComponent),
    data: {
      label: "Reporte_Control_Liquidacion",
      icon: "fact_check",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reporte-total-liquidacion-legajo",
    loadComponent: () =>
      import(
        "./components/reporte-total-liquidacion-legajo/reporte-total-liquidacion-legajo.component"
      ).then((m) => m.ReporteTotalLiquidacionLegajoComponent),
    data: {
      label: "Reporte_Total_Liquidacion_Legajo",
      icon: "summarize",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reporte-resumen-ganancias",
    loadComponent: () =>
      import(
        "./components/reporte-resumen-ganancias/reporte-resumen-ganancias.component"
      ).then((m) => m.ReporteResumenGananciasComponent),
    data: {
      label: "Reporte_Resumen_Ganancias",
      icon: "request_quote",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_libro-sueldos-digital",
    loadComponent: () =>
      import(
        "./components/libro-sueldos-digital/libro-sueldos-digital.component"
      ).then((m) => m.LibroSueldosDigitalComponent),
    data: {
      label: "Libro de Sueldos Digital",
      icon: "menu_book",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reporte-certificado-servicios",
    loadComponent: () =>
      import(
        "./components/certificado-servicios/certificado-servicios.component"
      ).then((m) => m.CertificadoServiciosComponent),
    data: {
      label: "Certificado_Servicios",
      icon: "workspace_premium",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reporte-netos-por-liquidacion",
    loadComponent: () =>
      import(
        "./components/reporte-netos-liquidacion/reporte-netos-liquidacion.component"
      ).then((m) => m.ReporteNetosLiquidacionComponent),
    data: {
      label: "Reporte_Netos_Liquidacion",
      icon: "payments",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_libro-sueldos",
    loadComponent: () =>
      import("./components/libro-sueldos/libro-sueldos.component").then((m) => m.LibroSueldosComponent),
    data: {
      label: "Libro de Sueldos",
      icon: "menu_book",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_siradig",
    loadComponent: () =>
      import("./components/siradig/siradig.component").then(
        (m) => m.SiradigComponent,
      ),
    data: {
      label: "SIRADIG - DDJJ de Ganancias (F.572)",
      icon: "description",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_sicore",
    loadComponent: () =>
      import("./components/sicore/sicore.component").then(
        (m) => m.SicoreComponent,
      ),
    data: {
      label: "SICORE - Retenciones de Ganancias",
      icon: "description",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_f1359",
    loadComponent: () =>
      import("./components/f1359/f1359.component").then((m) => m.F1359Component),
    data: {
      label: "F.1359 - Ganancias 4ta. Categoría",
      icon: "description",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_cierre-anual",
    loadComponent: () =>
      import("./components/cierre-anual/cierre-anual.component").then(
        (m) => m.CierreAnualComponent,
      ),
    data: {
      label: "Cierre_Anual",
      icon: "event_available",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_reversion-anual",
    loadComponent: () =>
      import("./components/reversion-anual/reversion-anual.component").then(
        (m) => m.ReversionAnualComponent,
      ),
    data: {
      label: "Reversión Cierre Anual",
      icon: "undo",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_copia-escalas-deducciones",
    loadComponent: () =>
      import("./components/copia-escalas-deducciones/copia-escalas-deducciones.component").then(
        (m) => m.CopiaEscalasDeduccionesComponent,
      ),
    canActivate: [AuthGuard, PermissionGuard],
    data: { label: "Copia de Escalas y Deduc.", icon: "content_copy", urlexterna: "LH" },
  },
  {
    path: "lh_sindicatos",
    loadChildren: () =>
      import("./components/sindicatos/sindicatos.routes").then(
        (m) => m.sindicatosRoutes,
      ),
    data: {
      label: "Sindicatos",
      icon: "groups",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_topes-mopre",
    loadComponent: () =>
      import("./components/topes-mopre/topes-mopre.component").then(
        (m) => m.TopesMopreComponent,
      ),
    data: {
      label: "Topes_MoPre",
      icon: "price_check",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_novedades-legajo",
    loadComponent: () =>
      import("./components/novedades_legajo/novedades-legajo.component").then(
        (m) => m.NovedadesLegajoComponent,
      ),
    data: {
      label: "Novedades_Legajo",
      icon: "assignment",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_novedades-aperturadas",
    loadComponent: () =>
      import("./components/novedades_aperturadas/novedades-aperturadas.component").then(
        (m) => m.NovedadesAperturasComponent,
      ),
    data: {
      label: "Novedades_Aperturadas",
      icon: "inbox",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_novedades-legajos-conceptos",
    loadComponent: () =>
      import("./components/novedades-legajos-conceptos/novedades-legajos-conceptos.component").then(
        (m) => m.NovedadesLegajosConceptosComponent,
      ),
    data: {
      label: "Novedades_Legajos_Conceptos",
      icon: "fact_check",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_notas-recibo-sueldos",
    loadComponent: () =>
      import("./components/notas-recibo-sueldos/notas-recibo-sueldos.component").then(
        (m) => m.NotasReciboSueldosComponent,
      ),
    data: {
      label: "Notas_Recibo_Sueldos",
      icon: "receipt_long",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_equivalencia-conceptos-afip",
    loadComponent: () =>
      import("./components/equivalencia-conceptos-afip/equivalencia-conceptos-afip.component").then(
        (m) => m.EquivalenciaConceptosAfipComponent,
      ),
    data: {
      label: "Equivalencia de Conceptos Condor-AFIP",
      icon: "sync_alt",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_conceptos-afip-parametros",
    loadComponent: () =>
      import(
        "./components/conceptos-afip-parametros/conceptos-afip-parametros.component"
      ).then((m) => m.ConceptosAfipParametrosComponent),
    data: {
      label: "Conceptos AFIP - Parámetros",
      icon: "tune",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_base-imponible-remuneraciones",
    loadComponent: () =>
      import("./components/base-imponible-remuneraciones/base-imponible-remuneraciones.component").then(
        (m) => m.BaseImponibleRemuneracionesComponent,
      ),
    data: {
      label: "Base Imponible de Remuneraciones",
      icon: "account_balance",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-tipos-dia",
    loadComponent: () =>
      import("./components/parte-diario/tipos-dia/tipos-dia.component").then(
        (m) => m.TiposDiaComponent,
      ),
    data: {
      label: "Tipos de Día",
      icon: "event_note",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-suplencias",
    loadComponent: () =>
      import("./components/parte-diario/suplencias/suplencias.component").then(
        (m) => m.SuplenciasComponent,
      ),
    data: {
      label: "Suplencias",
      icon: "supervisor_account",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-parametros",
    loadComponent: () =>
      import("./components/parte-diario/parametros/parametros.component").then(
        (m) => m.ParametrosComponent,
      ),
    data: {
      label: "Parametros_Parte_Diario",
      icon: "tune",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-parametros-lugar-de-trabajo",
    loadComponent: () =>
      import(
        "./components/parte-diario/par-lugar-trabajo/par-lugar-trabajo.component"
      ).then((m) => m.ParLugarTrabajoComponent),
    data: {
      label: "Parámetros por Lugar de Trabajo",
      icon: "pin_drop",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-parametros-convenio",
    loadComponent: () =>
      import(
        "./components/parte-diario/par-convenio/par-convenio.component"
      ).then((m) => m.ParConvenioComponent),
    data: {
      label: "Parámetros por Convenio",
      icon: "gavel",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-config-novedades",
    loadComponent: () =>
      import(
        "./components/parte-diario/config-novedades/config-novedades.component"
      ).then((m) => m.ConfigNovedadesComponent),
    data: {
      label: "Configuración de Novedades",
      icon: "rule",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-config-novedades/versiones",
    loadComponent: () =>
      import(
        "./components/parte-diario/config-novedades/versiones/versiones.component"
      ).then((m) => m.VersionesComponent),
    data: {
      label: "Reglas de la Configuración",
      icon: "history",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-lotes",
    loadComponent: () =>
      import("./components/parte-diario/lotes/lotes.component").then(
        (m) => m.LotesComponent,
      ),
    data: {
      label: "Lotes",
      icon: "inventory_2",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "lh_pd-lotes/control",
    loadComponent: () =>
      import("./components/parte-diario/lotes/control/control.component").then(
        (m) => m.ControlLoteComponent,
      ),
    data: {
      label: "Control de Lote",
      icon: "fact_check",
      urlexterna: "LH",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
